import { createElement } from 'preact' /** @jsx createElement */

const DropdownArrowDown = ({ className }) => (
  <svg version='1.1' xmlns='http://www.w3.org/2000/svg' className={className} focusable='false'>
    <g stroke='none' fill='none' fill-rule='evenodd'>
      <polygon fill='#000000' points='0 0 22 0 11 17' />
    </g>
  </svg>
)

export default DropdownArrowDown
